import { BaseModule } from '../base'

export interface IShareModel {}

/** 分享能力 */
export class ShareModule extends BaseModule<IShareModel> {
    protected initData(): IShareModel {
        return {}
    }
}
